import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import * as o from "react";
import * as Pe from "react-dom";
import { c as be } from "./index.rKs9bXHr.js";
import { u as Ne, c as wt, a as N } from "./index.stoqs9MZ.js";
import { c as ht } from "./index.BW3XI7yS.js";
import { u as L, c as gt } from "./index.B4ZV02se.js";
import { u as xt } from "./index.BhJrV2wu.js";
import { D as vt } from "./index.DNGle7LJ.js";
import { h as St, u as yt, R as Ct, F as It } from "./Combination.r_wXKfB6.js";
import { u as Ie } from "./index.BUG7NYeV.js";
import { c as Ee, R as Tt, a as bt, C as Nt, A as Rt } from "./index.C27qk3BS.js";
import { P as Pt } from "./index.RcubEhGW.js";
import { P as j } from "./index.DMLWxr4u.js";
import { u as Et } from "./index.BZPx6jYI.js";
import { a as _t } from "./index.BkBvp-m6.js";
import { c as jt } from "./index.C4-GUKyp.js";
import { F as Mt } from "./Check20.CqJjuR__.js";
import { F as _e } from "./ChevronDown20.NQYj4T82.js";
import { c as U } from "./index.CxSWpsOB.js";
function Ot(t) {
  const n = o.useRef(t);
  return o.useEffect(() => {
    n.current = t;
  }), o.useMemo(() => (...e) => n.current?.(...e), []);
}
var z = globalThis?.document ? o.useLayoutEffect : () => {
}, At = [" ", "Enter", "ArrowUp", "ArrowDown"], Dt = [" ", "Enter"], Q = "Select", [ie, de, Lt] = ht(Q), [oe, Ao] = wt(Q, [
  Lt,
  Ee
]), ue = Ee(), [kt, Y] = oe(Q), [Bt, Vt] = oe(Q), je = (t) => {
  const {
    __scopeSelect: n,
    children: e,
    open: c,
    defaultOpen: s,
    onOpenChange: u,
    value: a,
    defaultValue: l,
    onValueChange: i,
    dir: f,
    name: g,
    autoComplete: S,
    disabled: R,
    required: T,
    form: C
  } = t, d = ue(n), [w, x] = o.useState(null), [m, h] = o.useState(null), [W, M] = o.useState(!1), ne = xt(f), [P, A] = Ne({
    prop: c,
    defaultProp: s ?? !1,
    onChange: u,
    caller: Q
  }), [K, Z] = Ne({
    prop: a,
    defaultProp: l,
    onChange: i,
    caller: Q
  }), k = o.useRef(null), B = w ? C || !!w.closest("form") : !0, [$, V] = o.useState(/* @__PURE__ */ new Set()), H = Array.from($).map((E) => E.props.value).join(";");
  return /* @__PURE__ */ r.jsx(Tt, { ...d, children: /* @__PURE__ */ r.jsxs(
    kt,
    {
      required: T,
      scope: n,
      trigger: w,
      onTriggerChange: x,
      valueNode: m,
      onValueNodeChange: h,
      valueNodeHasChildren: W,
      onValueNodeHasChildrenChange: M,
      contentId: Ie(),
      value: K,
      onValueChange: Z,
      open: P,
      onOpenChange: A,
      dir: ne,
      triggerPointerDownPosRef: k,
      disabled: R,
      children: [
        /* @__PURE__ */ r.jsx(ie.Provider, { scope: n, children: /* @__PURE__ */ r.jsx(
          Bt,
          {
            scope: t.__scopeSelect,
            onNativeOptionAdd: o.useCallback((E) => {
              V((D) => new Set(D).add(E));
            }, []),
            onNativeOptionRemove: o.useCallback((E) => {
              V((D) => {
                const F = new Set(D);
                return F.delete(E), F;
              });
            }, []),
            children: e
          }
        ) }),
        B ? /* @__PURE__ */ r.jsxs(
          ot,
          {
            "aria-hidden": !0,
            required: T,
            tabIndex: -1,
            name: g,
            autoComplete: S,
            value: K,
            onChange: (E) => Z(E.target.value),
            disabled: R,
            form: C,
            children: [
              K === void 0 ? /* @__PURE__ */ r.jsx("option", { value: "" }) : null,
              Array.from($)
            ]
          },
          H
        ) : null
      ]
    }
  ) });
};
je.displayName = Q;
var Me = "SelectTrigger", Oe = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, disabled: c = !1, ...s } = t, u = ue(e), a = Y(Me, e), l = a.disabled || c, i = L(n, a.onTriggerChange), f = de(e), g = o.useRef("touch"), [S, R, T] = rt((d) => {
      const w = f().filter((h) => !h.disabled), x = w.find((h) => h.value === a.value), m = st(w, d, x);
      m !== void 0 && a.onValueChange(m.value);
    }), C = (d) => {
      l || (a.onOpenChange(!0), T()), d && (a.triggerPointerDownPosRef.current = {
        x: Math.round(d.pageX),
        y: Math.round(d.pageY)
      });
    };
    return /* @__PURE__ */ r.jsx(bt, { asChild: !0, ...u, children: /* @__PURE__ */ r.jsx(
      j.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: l,
        "data-disabled": l ? "" : void 0,
        "data-placeholder": nt(a.value) ? "" : void 0,
        ...s,
        ref: i,
        onClick: N(s.onClick, (d) => {
          d.currentTarget.focus(), g.current !== "mouse" && C(d);
        }),
        onPointerDown: N(s.onPointerDown, (d) => {
          g.current = d.pointerType;
          const w = d.target;
          w.hasPointerCapture(d.pointerId) && w.releasePointerCapture(d.pointerId), d.button === 0 && d.ctrlKey === !1 && d.pointerType === "mouse" && (C(d), d.preventDefault());
        }),
        onKeyDown: N(s.onKeyDown, (d) => {
          const w = S.current !== "";
          !(d.ctrlKey || d.altKey || d.metaKey) && d.key.length === 1 && R(d.key), !(w && d.key === " ") && At.includes(d.key) && (C(), d.preventDefault());
        })
      }
    ) });
  }
);
Oe.displayName = Me;
var Ae = "SelectValue", De = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, className: c, style: s, children: u, placeholder: a = "", ...l } = t, i = Y(Ae, e), { onValueNodeHasChildrenChange: f } = i, g = u !== void 0, S = L(n, i.onValueNodeChange);
    return z(() => {
      f(g);
    }, [f, g]), /* @__PURE__ */ r.jsx(
      j.span,
      {
        ...l,
        ref: S,
        style: { pointerEvents: "none" },
        children: nt(i.value) ? /* @__PURE__ */ r.jsx(r.Fragment, { children: a }) : u
      }
    );
  }
);
De.displayName = Ae;
var Ht = "SelectIcon", Le = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, children: c, ...s } = t;
    return /* @__PURE__ */ r.jsx(j.span, { "aria-hidden": !0, ...s, ref: n, children: c || "▼" });
  }
);
Le.displayName = Ht;
var Ft = "SelectPortal", ke = (t) => /* @__PURE__ */ r.jsx(Pt, { asChild: !0, ...t });
ke.displayName = Ft;
var ee = "SelectContent", Be = o.forwardRef(
  (t, n) => {
    const e = Y(ee, t.__scopeSelect), [c, s] = o.useState();
    if (z(() => {
      s(new DocumentFragment());
    }, []), !e.open) {
      const u = c;
      return u ? Pe.createPortal(
        /* @__PURE__ */ r.jsx(Ve, { scope: t.__scopeSelect, children: /* @__PURE__ */ r.jsx(ie.Slot, { scope: t.__scopeSelect, children: /* @__PURE__ */ r.jsx("div", { children: t.children }) }) }),
        u
      ) : null;
    }
    return /* @__PURE__ */ r.jsx(He, { ...t, ref: n });
  }
);
Be.displayName = ee;
var O = 10, [Ve, q] = oe(ee), Ut = "SelectContentImpl", Wt = gt("SelectContent.RemoveScroll"), He = o.forwardRef(
  (t, n) => {
    const {
      __scopeSelect: e,
      position: c = "item-aligned",
      onCloseAutoFocus: s,
      onEscapeKeyDown: u,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: l,
      sideOffset: i,
      align: f,
      alignOffset: g,
      arrowPadding: S,
      collisionBoundary: R,
      collisionPadding: T,
      sticky: C,
      hideWhenDetached: d,
      avoidCollisions: w,
      //
      ...x
    } = t, m = Y(ee, e), [h, W] = o.useState(null), [M, ne] = o.useState(null), P = L(n, (p) => W(p)), [A, K] = o.useState(null), [Z, k] = o.useState(
      null
    ), B = de(e), [$, V] = o.useState(!1), H = o.useRef(!1);
    o.useEffect(() => {
      if (h) return St(h);
    }, [h]), yt();
    const E = o.useCallback(
      (p) => {
        const [I, ..._] = B().map((b) => b.ref.current), [v] = _.slice(-1), y = document.activeElement;
        for (const b of p)
          if (b === y || (b?.scrollIntoView({ block: "nearest" }), b === I && M && (M.scrollTop = 0), b === v && M && (M.scrollTop = M.scrollHeight), b?.focus(), document.activeElement !== y)) return;
      },
      [B, M]
    ), D = o.useCallback(
      () => E([A, h]),
      [E, A, h]
    );
    o.useEffect(() => {
      $ && D();
    }, [$, D]);
    const { onOpenChange: F, triggerPointerDownPosRef: G } = m;
    o.useEffect(() => {
      if (h) {
        let p = { x: 0, y: 0 };
        const I = (v) => {
          p = {
            x: Math.abs(Math.round(v.pageX) - (G.current?.x ?? 0)),
            y: Math.abs(Math.round(v.pageY) - (G.current?.y ?? 0))
          };
        }, _ = (v) => {
          p.x <= 10 && p.y <= 10 ? v.preventDefault() : h.contains(v.target) || F(!1), document.removeEventListener("pointermove", I), G.current = null;
        };
        return G.current !== null && (document.addEventListener("pointermove", I), document.addEventListener("pointerup", _, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", I), document.removeEventListener("pointerup", _, { capture: !0 });
        };
      }
    }, [h, F, G]), o.useEffect(() => {
      const p = () => F(!1);
      return window.addEventListener("blur", p), window.addEventListener("resize", p), () => {
        window.removeEventListener("blur", p), window.removeEventListener("resize", p);
      };
    }, [F]);
    const [pe, ae] = rt((p) => {
      const I = B().filter((y) => !y.disabled), _ = I.find((y) => y.ref.current === document.activeElement), v = st(I, p, _);
      v && setTimeout(() => v.ref.current.focus());
    }), fe = o.useCallback(
      (p, I, _) => {
        const v = !H.current && !_;
        (m.value !== void 0 && m.value === I || v) && (K(p), v && (H.current = !0));
      },
      [m.value]
    ), me = o.useCallback(() => h?.focus(), [h]), te = o.useCallback(
      (p, I, _) => {
        const v = !H.current && !_;
        (m.value !== void 0 && m.value === I || v) && k(p);
      },
      [m.value]
    ), le = c === "popper" ? xe : Fe, re = le === xe ? {
      side: l,
      sideOffset: i,
      align: f,
      alignOffset: g,
      arrowPadding: S,
      collisionBoundary: R,
      collisionPadding: T,
      sticky: C,
      hideWhenDetached: d,
      avoidCollisions: w
    } : {};
    return /* @__PURE__ */ r.jsx(
      Ve,
      {
        scope: e,
        content: h,
        viewport: M,
        onViewportChange: ne,
        itemRefCallback: fe,
        selectedItem: A,
        onItemLeave: me,
        itemTextRefCallback: te,
        focusSelectedItem: D,
        selectedItemText: Z,
        position: c,
        isPositioned: $,
        searchRef: pe,
        children: /* @__PURE__ */ r.jsx(Ct, { as: Wt, allowPinchZoom: !0, children: /* @__PURE__ */ r.jsx(
          It,
          {
            asChild: !0,
            trapped: m.open,
            onMountAutoFocus: (p) => {
              p.preventDefault();
            },
            onUnmountAutoFocus: N(s, (p) => {
              m.trigger?.focus({ preventScroll: !0 }), p.preventDefault();
            }),
            children: /* @__PURE__ */ r.jsx(
              vt,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: u,
                onPointerDownOutside: a,
                onFocusOutside: (p) => p.preventDefault(),
                onDismiss: () => m.onOpenChange(!1),
                children: /* @__PURE__ */ r.jsx(
                  le,
                  {
                    role: "listbox",
                    id: m.contentId,
                    "data-state": m.open ? "open" : "closed",
                    dir: m.dir,
                    onContextMenu: (p) => p.preventDefault(),
                    ...x,
                    ...re,
                    onPlaced: () => V(!0),
                    ref: P,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...x.style
                    },
                    onKeyDown: N(x.onKeyDown, (p) => {
                      const I = p.ctrlKey || p.altKey || p.metaKey;
                      if (p.key === "Tab" && p.preventDefault(), !I && p.key.length === 1 && ae(p.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(p.key)) {
                        let v = B().filter((y) => !y.disabled).map((y) => y.ref.current);
                        if (["ArrowUp", "End"].includes(p.key) && (v = v.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(p.key)) {
                          const y = p.target, b = v.indexOf(y);
                          v = v.slice(b + 1);
                        }
                        setTimeout(() => E(v)), p.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
He.displayName = Ut;
var Kt = "SelectItemAlignedPosition", Fe = o.forwardRef((t, n) => {
  const { __scopeSelect: e, onPlaced: c, ...s } = t, u = Y(ee, e), a = q(ee, e), [l, i] = o.useState(null), [f, g] = o.useState(null), S = L(n, (P) => g(P)), R = de(e), T = o.useRef(!1), C = o.useRef(!0), { viewport: d, selectedItem: w, selectedItemText: x, focusSelectedItem: m } = a, h = o.useCallback(() => {
    if (u.trigger && u.valueNode && l && f && d && w && x) {
      const P = u.trigger.getBoundingClientRect(), A = f.getBoundingClientRect(), K = u.valueNode.getBoundingClientRect(), Z = x.getBoundingClientRect();
      if (u.dir !== "rtl") {
        const y = Z.left - A.left, b = K.left - y, X = P.left - b, J = P.width + X, we = Math.max(J, A.width), he = window.innerWidth - O, ge = be(b, [
          O,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(O, he - we)
        ]);
        l.style.minWidth = J + "px", l.style.left = ge + "px";
      } else {
        const y = A.right - Z.right, b = window.innerWidth - K.right - y, X = window.innerWidth - P.right - b, J = P.width + X, we = Math.max(J, A.width), he = window.innerWidth - O, ge = be(b, [
          O,
          Math.max(O, he - we)
        ]);
        l.style.minWidth = J + "px", l.style.right = ge + "px";
      }
      const k = R(), B = window.innerHeight - O * 2, $ = d.scrollHeight, V = window.getComputedStyle(f), H = parseInt(V.borderTopWidth, 10), E = parseInt(V.paddingTop, 10), D = parseInt(V.borderBottomWidth, 10), F = parseInt(V.paddingBottom, 10), G = H + E + $ + F + D, pe = Math.min(w.offsetHeight * 5, G), ae = window.getComputedStyle(d), fe = parseInt(ae.paddingTop, 10), me = parseInt(ae.paddingBottom, 10), te = P.top + P.height / 2 - O, le = B - te, re = w.offsetHeight / 2, p = w.offsetTop + re, I = H + E + p, _ = G - I;
      if (I <= te) {
        const y = k.length > 0 && w === k[k.length - 1].ref.current;
        l.style.bottom = "0px";
        const b = f.clientHeight - d.offsetTop - d.offsetHeight, X = Math.max(
          le,
          re + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (y ? me : 0) + b + D
        ), J = I + X;
        l.style.height = J + "px";
      } else {
        const y = k.length > 0 && w === k[0].ref.current;
        l.style.top = "0px";
        const X = Math.max(
          te,
          H + d.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (y ? fe : 0) + re
        ) + _;
        l.style.height = X + "px", d.scrollTop = I - te + d.offsetTop;
      }
      l.style.margin = `${O}px 0`, l.style.minHeight = pe + "px", l.style.maxHeight = B + "px", c?.(), requestAnimationFrame(() => T.current = !0);
    }
  }, [
    R,
    u.trigger,
    u.valueNode,
    l,
    f,
    d,
    w,
    x,
    u.dir,
    c
  ]);
  z(() => h(), [h]);
  const [W, M] = o.useState();
  z(() => {
    f && M(window.getComputedStyle(f).zIndex);
  }, [f]);
  const ne = o.useCallback(
    (P) => {
      P && C.current === !0 && (h(), m?.(), C.current = !1);
    },
    [h, m]
  );
  return /* @__PURE__ */ r.jsx(
    Gt,
    {
      scope: e,
      contentWrapper: l,
      shouldExpandOnScrollRef: T,
      onScrollButtonChange: ne,
      children: /* @__PURE__ */ r.jsx(
        "div",
        {
          ref: i,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: W
          },
          children: /* @__PURE__ */ r.jsx(
            j.div,
            {
              ...s,
              ref: S,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...s.style
              }
            }
          )
        }
      )
    }
  );
});
Fe.displayName = Kt;
var $_t = "SelectPopperPosition", xe = o.forwardRef((t, n) => {
  const {
    __scopeSelect: e,
    align: c = "start",
    collisionPadding: s = O,
    ...u
  } = t, a = ue(e);
  return /* @__PURE__ */ r.jsx(
    Nt,
    {
      ...a,
      ...u,
      ref: n,
      align: c,
      collisionPadding: s,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...u.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
xe.displayName = $_t;
var [Gt, Te] = oe(ee, {}), ve = "SelectViewport", Ue = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, nonce: c, ...s } = t, u = q(ve, e), a = Te(ve, e), l = L(n, u.onViewportChange), i = o.useRef(0);
    return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      /* @__PURE__ */ r.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: c
        }
      ),
      /* @__PURE__ */ r.jsx(ie.Slot, { scope: e, children: /* @__PURE__ */ r.jsx(
        j.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...s,
          ref: l,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...s.style
          },
          onScroll: N(s.onScroll, (f) => {
            const g = f.currentTarget, { contentWrapper: S, shouldExpandOnScrollRef: R } = a;
            if (R?.current && S) {
              const T = Math.abs(i.current - g.scrollTop);
              if (T > 0) {
                const C = window.innerHeight - O * 2, d = parseFloat(S.style.minHeight), w = parseFloat(S.style.height), x = Math.max(d, w);
                if (x < C) {
                  const m = x + T, h = Math.min(C, m), W = m - h;
                  S.style.height = h + "px", S.style.bottom === "0px" && (g.scrollTop = W > 0 ? W : 0, S.style.justifyContent = "flex-end");
                }
              }
            }
            i.current = g.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Ue.displayName = ve;
var We = "SelectGroup", [zt, Yt] = oe(We), Ke = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...c } = t, s = Ie();
    return /* @__PURE__ */ r.jsx(zt, { scope: e, id: s, children: /* @__PURE__ */ r.jsx(j.div, { role: "group", "aria-labelledby": s, ...c, ref: n }) });
  }
);
Ke.displayName = We;
var $e = "SelectLabel", Ge = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...c } = t, s = Yt($e, e);
    return /* @__PURE__ */ r.jsx(j.div, { id: s.id, ...c, ref: n });
  }
);
Ge.displayName = $e;
var ce = "SelectItem", [qt, ze] = oe(ce), Ye = o.forwardRef(
  (t, n) => {
    const {
      __scopeSelect: e,
      value: c,
      disabled: s = !1,
      textValue: u,
      ...a
    } = t, l = Y(ce, e), i = q(ce, e), f = l.value === c, [g, S] = o.useState(u ?? ""), [R, T] = o.useState(!1), C = L(
      n,
      (m) => i.itemRefCallback?.(m, c, s)
    ), d = Ie(), w = o.useRef("touch"), x = () => {
      s || (l.onValueChange(c), l.onOpenChange(!1));
    };
    if (c === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ r.jsx(
      qt,
      {
        scope: e,
        value: c,
        disabled: s,
        textId: d,
        isSelected: f,
        onItemTextChange: o.useCallback((m) => {
          S((h) => h || (m?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ r.jsx(
          ie.ItemSlot,
          {
            scope: e,
            value: c,
            disabled: s,
            textValue: g,
            children: /* @__PURE__ */ r.jsx(
              j.div,
              {
                role: "option",
                "aria-labelledby": d,
                "data-highlighted": R ? "" : void 0,
                "aria-selected": f && R,
                "data-state": f ? "checked" : "unchecked",
                "aria-disabled": s || void 0,
                "data-disabled": s ? "" : void 0,
                tabIndex: s ? void 0 : -1,
                ...a,
                ref: C,
                onFocus: N(a.onFocus, () => T(!0)),
                onBlur: N(a.onBlur, () => T(!1)),
                onClick: N(a.onClick, () => {
                  w.current !== "mouse" && x();
                }),
                onPointerUp: N(a.onPointerUp, () => {
                  w.current === "mouse" && x();
                }),
                onPointerDown: N(a.onPointerDown, (m) => {
                  w.current = m.pointerType;
                }),
                onPointerMove: N(a.onPointerMove, (m) => {
                  w.current = m.pointerType, s ? i.onItemLeave?.() : w.current === "mouse" && m.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: N(a.onPointerLeave, (m) => {
                  m.currentTarget === document.activeElement && i.onItemLeave?.();
                }),
                onKeyDown: N(a.onKeyDown, (m) => {
                  i.searchRef?.current !== "" && m.key === " " || (Dt.includes(m.key) && x(), m.key === " " && m.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Ye.displayName = ce;
var se = "SelectItemText", qe = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, className: c, style: s, ...u } = t, a = Y(se, e), l = q(se, e), i = ze(se, e), f = Vt(se, e), [g, S] = o.useState(null), R = L(
      n,
      (x) => S(x),
      i.onItemTextChange,
      (x) => l.itemTextRefCallback?.(x, i.value, i.disabled)
    ), T = g?.textContent, C = o.useMemo(
      () => /* @__PURE__ */ r.jsx("option", { value: i.value, disabled: i.disabled, children: T }, i.value),
      [i.disabled, i.value, T]
    ), { onNativeOptionAdd: d, onNativeOptionRemove: w } = f;
    return z(() => (d(C), () => w(C)), [d, w, C]), /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      /* @__PURE__ */ r.jsx(j.span, { id: i.textId, ...u, ref: R }),
      i.isSelected && a.valueNode && !a.valueNodeHasChildren ? Pe.createPortal(u.children, a.valueNode) : null
    ] });
  }
);
qe.displayName = se;
var Ze = "SelectItemIndicator", Xe = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...c } = t;
    return ze(Ze, e).isSelected ? /* @__PURE__ */ r.jsx(j.span, { "aria-hidden": !0, ...c, ref: n }) : null;
  }
);
Xe.displayName = Ze;
var Se = "SelectScrollUpButton", Je = o.forwardRef((t, n) => {
  const e = q(Se, t.__scopeSelect), c = Te(Se, t.__scopeSelect), [s, u] = o.useState(!1), a = L(n, c.onScrollButtonChange);
  return z(() => {
    if (e.viewport && e.isPositioned) {
      let l = function() {
        const f = i.scrollTop > 0;
        u(f);
      };
      const i = e.viewport;
      return l(), i.addEventListener("scroll", l), () => i.removeEventListener("scroll", l);
    }
  }, [e.viewport, e.isPositioned]), s ? /* @__PURE__ */ r.jsx(
    et,
    {
      ...t,
      ref: a,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: i } = e;
        l && i && (l.scrollTop = l.scrollTop - i.offsetHeight);
      }
    }
  ) : null;
});
Je.displayName = Se;
var ye = "SelectScrollDownButton", Qe = o.forwardRef((t, n) => {
  const e = q(ye, t.__scopeSelect), c = Te(ye, t.__scopeSelect), [s, u] = o.useState(!1), a = L(n, c.onScrollButtonChange);
  return z(() => {
    if (e.viewport && e.isPositioned) {
      let l = function() {
        const f = i.scrollHeight - i.clientHeight, g = Math.ceil(i.scrollTop) < f;
        u(g);
      };
      const i = e.viewport;
      return l(), i.addEventListener("scroll", l), () => i.removeEventListener("scroll", l);
    }
  }, [e.viewport, e.isPositioned]), s ? /* @__PURE__ */ r.jsx(
    et,
    {
      ...t,
      ref: a,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: i } = e;
        l && i && (l.scrollTop = l.scrollTop + i.offsetHeight);
      }
    }
  ) : null;
});
Qe.displayName = ye;
var et = o.forwardRef((t, n) => {
  const { __scopeSelect: e, onAutoScroll: c, ...s } = t, u = q("SelectScrollButton", e), a = o.useRef(null), l = de(e), i = o.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return o.useEffect(() => () => i(), [i]), z(() => {
    l().find((g) => g.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [l]), /* @__PURE__ */ r.jsx(
    j.div,
    {
      "aria-hidden": !0,
      ...s,
      ref: n,
      style: { flexShrink: 0, ...s.style },
      onPointerDown: N(s.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(c, 50));
      }),
      onPointerMove: N(s.onPointerMove, () => {
        u.onItemLeave?.(), a.current === null && (a.current = window.setInterval(c, 50));
      }),
      onPointerLeave: N(s.onPointerLeave, () => {
        i();
      })
    }
  );
}), Zt = "SelectSeparator", tt = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...c } = t;
    return /* @__PURE__ */ r.jsx(j.div, { "aria-hidden": !0, ...c, ref: n });
  }
);
tt.displayName = Zt;
var Ce = "SelectArrow", Xt = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...c } = t, s = ue(e), u = Y(Ce, e), a = q(Ce, e);
    return u.open && a.position === "popper" ? /* @__PURE__ */ r.jsx(Rt, { ...s, ...c, ref: n }) : null;
  }
);
Xt.displayName = Ce;
var Jt = "SelectBubbleInput", ot = o.forwardRef(
  ({ __scopeSelect: t, value: n, ...e }, c) => {
    const s = o.useRef(null), u = L(c, s), a = Et(n);
    return o.useEffect(() => {
      const l = s.current;
      if (!l) return;
      const i = window.HTMLSelectElement.prototype, g = Object.getOwnPropertyDescriptor(
        i,
        "value"
      ).set;
      if (a !== n && g) {
        const S = new Event("change", { bubbles: !0 });
        g.call(l, n), l.dispatchEvent(S);
      }
    }, [a, n]), /* @__PURE__ */ r.jsx(
      j.select,
      {
        ...e,
        style: { ..._t, ...e.style },
        ref: u,
        defaultValue: n
      }
    );
  }
);
ot.displayName = Jt;
function nt(t) {
  return t === "" || t === void 0;
}
function rt(t) {
  const n = Ot(t), e = o.useRef(""), c = o.useRef(0), s = o.useCallback(
    (a) => {
      const l = e.current + a;
      n(l), function i(f) {
        e.current = f, window.clearTimeout(c.current), f !== "" && (c.current = window.setTimeout(() => i(""), 1e3));
      }(l);
    },
    [n]
  ), u = o.useCallback(() => {
    e.current = "", window.clearTimeout(c.current);
  }, []);
  return o.useEffect(() => () => window.clearTimeout(c.current), []), [e, s, u];
}
function st(t, n, e) {
  const s = n.length > 1 && Array.from(n).every((f) => f === n[0]) ? n[0] : n, u = e ? t.indexOf(e) : -1;
  let a = Qt(t, Math.max(u, 0));
  s.length === 1 && (a = a.filter((f) => f !== e));
  const i = a.find(
    (f) => f.textValue.toLowerCase().startsWith(s.toLowerCase())
  );
  return i !== e ? i : void 0;
}
function Qt(t, n) {
  return t.map((e, c) => t[(n + c) % t.length]);
}
var eo = je, at = Oe, to = De, Re = Le, oo = ke, lt = Be, no = Ue, ro = Ke, ct = Ge, it = Ye, so = qe, ao = Xe, dt = Je, ut = Qe, pt = tt;
const lo = (t, n) => /* @__PURE__ */ r.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: n, ...t, children: /* @__PURE__ */ r.jsx("path", { fill: "currentColor", d: "M10 5.75a.75.75 0 0 1 .53.22l5.25 5.25a.75.75 0 1 1-1.06 1.06L10 7.56l-4.72 4.72a.75.75 0 1 1-1.06-1.06l5.25-5.25a.75.75 0 0 1 .53-.22Z" }) }), co = o.forwardRef(lo), Do = eo, Lo = ro, ko = ({
  placeholder: t,
  disabled: n,
  children: e
}) => /* @__PURE__ */ r.jsx(to, { placeholder: t && /* @__PURE__ */ r.jsx("span", { className: U("tw-text-gray-600", {
  "tw-text-gray-500": n
}), children: t }), children: e }), io = jt("tw-relative tw-px-12 tw-py-8 tw-inline-flex tw-items-center tw-gap-12 tw-bg-base-white focus:tw-outline focus:tw-outline-2 focus:tw-outline-blue-800 focus:tw-outline-offset-1 tw-border-gray-400 focus:tw-border-gray-900 tw-border tw-rounded-4 tw-text-gray-900 placeholder:tw-text-gray-600 disabled:tw-text-gray-500 disabled:placeholder:tw-text-gray-500 tw-text-nowrap [&_.tw-select-trigger-children]:tw-truncate", {
  variants: {
    disabled: {
      true: "tw-text-gray-500",
      false: ""
    },
    fullWidth: {
      true: "tw-w-full",
      false: ""
    },
    error: {
      true: "tw-border-red-800 focus:tw-border-red-800",
      false: ""
    },
    readOnly: {
      true: "tw-pointer-events-none",
      false: ""
    },
    prefix: {
      true: "",
      false: ""
    },
    suffix: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [{
    prefix: !0,
    class: "tw-pl-40 tw-pr-12"
  }, {
    suffix: !0,
    class: "tw-pr-40 tw-pl-12"
  }, {
    suffix: !0,
    prefix: !0,
    class: "tw-pl-40 tw-pr-40"
  }]
}), uo = o.forwardRef(({
  className: t,
  children: n,
  prefix: e,
  suffix: c,
  errorMsg: s,
  fullWidth: u,
  testId: a,
  ...l
}, i) => /* @__PURE__ */ r.jsxs(at, { ref: i, "data-testid": a, translate: "no", className: U(io({
  prefix: !!e,
  suffix: !0,
  error: !!s,
  disabled: !!l.disabled,
  readOnly: !!l.readOnly,
  fullWidth: u
}), t), ...l, children: [
  e && /* @__PURE__ */ r.jsx(Re, { asChild: !0, children: /* @__PURE__ */ r.jsx("span", { className: "tw-h-full tw-inline-flex tw-absolute tw-top-0 tw-left-12 tw-items-center tw-justify-center tw-w-20", children: e }) }),
  /* @__PURE__ */ r.jsx("span", { className: "tw-select-trigger-children", children: n }),
  /* @__PURE__ */ r.jsx(Re, { asChild: !0, children: /* @__PURE__ */ r.jsx("span", { className: "tw-h-full tw-inline-flex tw-absolute tw-top-0 tw-right-12 tw-items-center tw-justify-center tw-w-20", children: c || /* @__PURE__ */ r.jsx(_e, {}) }) })
] }));
uo.displayName = at.displayName;
const ft = o.forwardRef(({
  className: t,
  ...n
}, e) => /* @__PURE__ */ r.jsx(dt, { ref: e, className: U("tw-flex tw-cursor-default tw-items-center tw-justify-center tw-py-4", t), ...n, children: /* @__PURE__ */ r.jsx(co, {}) }));
ft.displayName = dt.displayName;
const mt = o.forwardRef(({
  className: t,
  ...n
}, e) => /* @__PURE__ */ r.jsx(ut, { ref: e, className: U("tw-flex tw-cursor-default tw-items-center tw-justify-center tw-py-4", t), ...n, children: /* @__PURE__ */ r.jsx(_e, {}) }));
mt.displayName = ut.displayName;
const po = o.forwardRef(({
  className: t,
  children: n,
  position: e = "popper",
  ...c
}, s) => /* @__PURE__ */ r.jsx(oo, { children: /* @__PURE__ */ r.jsxs(lt, { ref: s, className: U("tw-relative tw-z-max tw-overflow-hidden tw-bg-base-white tw-shadow-lg tw-rounded-4 data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-8 data-[side=left]:tw-slide-in-from-right-8 data-[side=right]:tw-slide-in-from-left-8 data-[side=top]:tw-slide-in-from-bottom-8", e === "popper" && "data-[side=bottom]:tw-translate-y-4 data-[side=left]:tw--translate-x-4 data-[side=right]:tw-translate-x-4 data-[side=top]:tw--translate-y-4", t), style: {
  maxHeight: "268px"
}, position: e, translate: "no", ...c, children: [
  /* @__PURE__ */ r.jsx(ft, {}),
  /* @__PURE__ */ r.jsx(no, { className: U("tw-p-1", e === "popper" && "tw-h-[var(--radix-select-trigger-height)] tw-w-full tw-min-w-[var(--radix-select-trigger-width)]"), children: n }),
  /* @__PURE__ */ r.jsx(mt, {})
] }) }));
po.displayName = lt.displayName;
const fo = o.forwardRef(({
  className: t,
  ...n
}, e) => /* @__PURE__ */ r.jsx(ct, { ref: e, className: U("tw-py-4 tw-px-8 tw-body-2-m", t), ...n }));
fo.displayName = ct.displayName;
const mo = o.forwardRef(({
  className: t,
  testId: n,
  children: e,
  ...c
}, s) => /* @__PURE__ */ r.jsxs(it, { ref: s, "data-testid": n, className: U("tw-relative tw-flex tw-w-full tw-cursor-default tw-select-none tw-items-center tw-justify-between tw-py-8 tw-px-16 tw-body-2 tw-outline-none data-[disabled]:tw-pointer-events-none data-[disabled]:tw-text-gray-500 focus:tw-bg-gray-300", t), ...c, children: [
  /* @__PURE__ */ r.jsx(so, { children: e }),
  /* @__PURE__ */ r.jsx("span", { className: "tw-flex tw-items-center tw-justify-center", children: /* @__PURE__ */ r.jsx(ao, { children: /* @__PURE__ */ r.jsx(Mt, {}) }) })
] }));
mo.displayName = it.displayName;
const wo = o.forwardRef(({
  className: t,
  ...n
}, e) => /* @__PURE__ */ r.jsx(pt, { ref: e, className: U("tw--mx-4 tw-my-4 tw-h-px tw-bg-muted", t), ...n }));
wo.displayName = pt.displayName;
export {
  Do as S,
  po as a,
  Lo as b,
  mo as c,
  fo as d,
  mt as e,
  ft as f,
  wo as g,
  uo as h,
  ko as i,
  De as j,
  Oe as k
};
//# sourceMappingURL=Select.BBX9C9N8.js.map
